import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from './cx.ts';

/**
 * Standard empty state: icon well, one-line title, optional hint and
 * action. An empty screen is an invitation to act — always offer the
 * next step when one exists (DESIGN.md §6).
 */
interface Props {
  readonly title: ReactNode;
  readonly hint?: ReactNode;
  readonly action?: ReactNode;
  readonly icon?: ReactNode;
  readonly className?: string;
  readonly testId?: string;
}

export function EmptyState({ title, hint, action, icon, className, testId }: Props): JSX.Element {
  return (
    <div data-testid={testId} className={cx('flex flex-col items-center gap-2 px-6 py-12 text-center', className)}>
      <div className="mb-1 flex h-10 w-10 items-center justify-center rounded-lg bg-raised text-paper-low">
        {icon ?? <Inbox aria-hidden="true" className="h-5 w-5" />}
      </div>
      <p className="m-0 text-body font-medium text-paper-mid">{title}</p>
      {hint !== undefined && hint !== null ? <p className="m-0 max-w-sm text-dense text-paper-low">{hint}</p> : null}
      {action !== undefined && action !== null ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
